<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed } from "vue";
import ReceiptIcon from "#/assets/icons/table_order_receipt.svg";
import CardIcon from "#/assets/icons/table_payment_card.svg";
import ArrowLeft from "#/assets/iconsDynamic/ArrowLeft.vue";
import type { TableOrderIntent } from "../stages";

const props = defineProps<{
	payableCount: number;
}>();

const emit = defineEmits<{
	select: [intent: TableOrderIntent];
	"create-order": [];
}>();

const { t } = useTranslation();

const tiles = computed<Array<{ intent: TableOrderIntent; icon: string; accent: boolean; title: string; subtitle: string }>>(() => [
	{
		intent: "open",
		icon: ReceiptIcon,
		accent: false,
		title: t(`table-service.table-action.open.title`),
		subtitle: t(`table-service.table-action.open.subtitle`),
	},
	{
		intent: "pay",
		icon: CardIcon,
		accent: true,
		title: t(`table-service.table-action.pay.title`),
		subtitle: t(`table-service.table-action.pay.subtitle`, { count: props.payableCount }),
	},
]);
</script>

<template>
	<div class="table_actions">
		<button
			v-for="tile in tiles"
			:key="tile.intent"
			type="button"
			class="table_actions_item"
			:class="{ table_actions_item_accent: tile.accent }"
			@click="emit('select', tile.intent)"
		>
			<span class="table_actions_icon">
				<img :src="tile.icon" alt="">
			</span>
			<span class="table_actions_text">
				<b>{{ tile.title }}</b>
				<p>{{ tile.subtitle }}</p>
			</span>
			<ArrowLeft class="table_actions_arrow" />
		</button>

		<button type="button" class="table_actions_browse" @click="emit('create-order')">
			{{ t(`table-service.active-orders.create-order`) }}
			<ArrowLeft class="table_actions_arrow" />
		</button>
	</div>
</template>

<style lang="scss">
  @use './tableActions.scss';
</style>
